import { EmptyComponent } from '@react/FilterableList/Components/EmptyComponent'
import { useContext } from 'react'

import { WorkdayJobsContext } from '../WorkdayJobsContext'
import { TableProps } from './TableProps'

export default function Table({ visibleJobs, visibleCount, handleLoadMore }: TableProps) {
  const { hidelocation, hidejobtype, hidetypeofcontract, hideexperience, hidejobfunction, hidebusinessunit, hideproductgroup, filteredJobscount } =
    useContext(WorkdayJobsContext)
  const tableTdClass = 'cmp-filterable-list__table-td'
  if (filteredJobscount === 0) {
    return <EmptyComponent message={'No Data Found'} />
  }
  return (
    <div className="cmp-filterable-list">
      <div className="cmp-filterable-list__table-wrapper">
        <table className={`cmp-filterable-list__table`}>
          <thead className={'cmp-filterable-list__table-thead'}>
            <tr className={'cmp-filterable-list__table-row'}>
              <th className="cmp-filterable-list__table-th">
                <div className="cmp-filterable-list__table-th--wrapper">Title</div>
              </th>
              {!hidelocation && (
                <th className="cmp-filterable-list__table-th">
                  <div className="cmp-filterable-list__table-th--wrapper">Location</div>
                </th>
              )}
              {!hidejobtype && (
                <th className="cmp-filterable-list__table-th">
                  <div className="cmp-filterable-list__table-th--wrapper">Job Type</div>
                </th>
              )}
              {!hidetypeofcontract && (
                <th className="cmp-filterable-list__table-th">
                  <div className="cmp-filterable-list__table-th--wrapper">Contract Type</div>
                </th>
              )}
              {!hideexperience && (
                <th className="cmp-filterable-list__table-th">
                  <div className="cmp-filterable-list__table-th--wrapper">Experience</div>
                </th>
              )}
              {!hidejobfunction && (
                <th className="cmp-filterable-list__table-th">
                  <div className="cmp-filterable-list__table-th--wrapper">Job Function</div>
                </th>
              )}
              {!hidebusinessunit && (
                <th className="cmp-filterable-list__table-th">
                  <div className="cmp-filterable-list__table-th--wrapper">Business Unit</div>
                </th>
              )}
              {!hideproductgroup && (
                <th className="cmp-filterable-list__table-th">
                  <div className="cmp-filterable-list__table-th--wrapper">Product Group</div>
                </th>
              )}
            </tr>
          </thead>
          <tbody className={'cmp-filterable-list__table-tbody'}>
            {visibleJobs?.map((job, index) => (
              <tr className="cmp-filterable-list__table-row" key={index}>
                <td className={tableTdClass}>
                  <a href={job.applyNowUrl} className="cmp-filterable-list__list-link" target="_blank" rel="noopener noreferrer">
                    {job.title}
                  </a>
                </td>
                {!hidelocation && <td className={tableTdClass}>{job.locations}</td>}
                {!hidejobtype && <td className={tableTdClass}>{job.jobType}</td>}
                {!hidetypeofcontract && <td className={tableTdClass}>{job.typeOfContract}</td>}
                {!hideexperience && <td className={tableTdClass}>{job.experience}</td>}
                {!hidejobfunction && <td className={tableTdClass}>{job.jobFunction}</td>}
                {!hidebusinessunit && <td className={tableTdClass}>{job.businessUnit}</td>}
                {!hideproductgroup && <td className={tableTdClass}>{job.productGroup}</td>}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {visibleCount < filteredJobscount && (
        <div className={`cmp-filterable-list__buttons-wrapper cmp-filterable-list__button--center`}>
          <button className={`cmp-button cmp-button--secondary-positive`} onClick={handleLoadMore}>
            {`Load More`}
            <span className="cmp-button__icon icon-keyboard_arrow_down icon--md" aria-hidden="true"></span>
          </button>
        </div>
      )}
    </div>
  )
}
